<template>
    <section class="side-menu-left-container">
        <section class="side-menu-left-title">
            <button>
                <i class="fal fa-chart-bar" />
            </button>
            <h3>Relatórios</h3>
        </section>

        <section class="side-menu-left" data-cy="all">
            <div v-if="loader.getReports" class="load-container">
                <ui-load-indicator :h="50" color="#69D296" :stroke="8" />
            </div>

            <div>
                <a 
                    v-for="(item, index) in sideMenu" 
                    :key="index" 
                    :class="{'active': index === classActive }" 
                    @click="getReports(item.category, item.file, index)" 
                >
                    <span>{{ item.title }}</span>
                    <span><i class="fal fa-chevron-right" /></span>
                </a>
            </div>

        </section>
    </section>
</template>

<script>
import { reportsCategory } from '@/services/axios'
import { uiLoadIndicator } from '@/components/ui'
import { storage } from '@/services/storage'

const defaultLoader = () => ({
	getReports: true,
})

export default {
	name: 'side-menu-left',
	components: {
		uiLoadIndicator,
	},

	data() {
		return {
			sideMenu: [],
			loader: { ...defaultLoader() },
			classActive: null
		}
	},

	async mounted() {
		this.classActive = 0

        /**
        * Determina se a requisição será feita no Data Lake com base na instância da empresa.
        */
		const getStorage = JSON.parse(storage.get('api_config'))
      	const instance = getStorage.instance
        const reportsCategoryInstance = await reportsCategory.defineVersionReports(instance)

		/**
		 * Chama as categorias dos relatórios
		*/
		reportsCategoryInstance.getAllV2('categories')
			.then(response => {
				const data = Object.values(response.data).map(item => {
					item.title = item.category.charAt(0) + item.category.toLowerCase().slice(1)

					return item
				})
				
				this.sideMenu = data
				// Seta a configuração do primeiro grupo de relatórios
				if (data && data.length) this.getReports(data[0].category, data[0].file, 0)
				this.loader.getReports = false
			})
			.catch(error => {
				if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
				console.log(error)
			})
	},

	methods: {
		/**
		 * Event handler que trata o evento de quando uma categoria de relatórios é selecionada
		 */
		getReports(item, categoryFile, index) {
			this.$gtm.trackEvent({
				event: "fac_button_click",
				category: "vue-relatorio-planilhas-new",
				action: "click",
				label: `Relatório - ${categoryFile}`
			})

			const reportData = {
				categoryFile,
				fileName: "",
				fields: [],
				filters: [],
				customFields: []
			}

			storage.set('report_data', JSON.stringify(reportData))

			this.classActive = index
			this.$root.$emit('set-new-reports', item, categoryFile)
		},
	},
}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>
